import React from "react";

function InfoTeam() {
    return (
        <div className="info-detail">
            <p className="info-title">팀원소개</p>
            <p className="info-item">전성빈</p>
            <p className="info-item-item">- 총괄(PM), AI 개발</p>
            <p className="info-item">이재원</p>
            <p className="info-item-item">- 데이터 관리</p>
            <p className="info-item">이승민</p>
            <p className="info-item-item">- 백엔드,클라우드 배포</p>
            <p className="info-item">우성민</p>
            <p className="info-item-item">- 데이터 시각화, UI</p>
            <p className="info-item">장우성</p>
            <p className="info-item-item">- 자연어 처리</p>
        </div>
    );
}

export default InfoTeam;